import React from "react";

const SummaryReturnPrompt = ({ summaryReturnSection, sectionKey, onBackToSummary }) => {
  if (summaryReturnSection !== sectionKey) {
    return null;
  }

  return (
    <div
      style={{
        margin: "0 0 10px 0",
        padding: "10px 12px",
        borderRadius: "6px",
        background: "#eff6ff",
        border: "1px solid #bfdbfe",
        color: "#1d4ed8",
        fontSize: "12px",
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <span>You came here from Summary. After updating, return to review.</span>
      <button
        type="button"
        onClick={onBackToSummary}
        style={{
          padding: "7px 10px",
          background: "#dbeafe",
          color: "#1d4ed8",
          border: "1px solid #bfdbfe",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "12px",
          fontWeight: "600",
        }}
      >
        Back to Summary
      </button>
    </div>
  );
};

export default SummaryReturnPrompt;
